import { registryApi } from '@/features/publicsite/registry/api/registryApi';
import { LIBRARY_PAGE_SIZE } from '@/features/publicsite/registry/libraryListing';
import type { LibraryPageResponse } from '@/features/publicsite/types/registry/LibraryPageResponse';
import { useServerPage } from '@/services/useServerPage';

/**
 * One page of the library's own holdings for the filters in the URL — or nothing at all when
 * `showNational` is off, or when the page could not be loaded.
 *
 * core/web/PageResponse — the envelope every paged public endpoint answers with. The listing
 * used to be an unpaged array: /biblioteca returned and rendered the whole table in one
 * response, and the filtering happened in Java after loading all of it.
 *
 * useServerPage, so paging through quickly shows the page asked for last rather than whichever
 * answer landed last.
 */
export function useLibraryPage(
  params: URLSearchParams,
  page: number,
  showNational: boolean,
): LibraryPageResponse | null {
  const key = JSON.stringify([params.toString(), page, showNational]);
  const answer = useServerPage(
    () =>
      showNational
        ? registryApi.libraryPage(params, page, LIBRARY_PAGE_SIZE)
        : Promise.resolve(null),
    key,
  );
  return showNational && !answer.failed ? answer.data : null;
}
